import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Unread = ({ children, empty, red, gray, small, showTripleDigits, transparent, warning, white }) => (
	<StyledUnread
		small={small}
		doubleDigits={children > 9}
		tripleDigits={children > 99}
		empty={empty}
		red={red}
		gray={gray}
		warning={warning}
		transparent={transparent}
		white={white}
	>
		{!showTripleDigits && children > 99 ? '99+' : children}
	</StyledUnread>
)

Unread.propTypes = {
	children: PropTypes.number.isRequired,
	empty: PropTypes.bool,
	red: PropTypes.bool,
	gray: PropTypes.bool,
	small: PropTypes.bool,
	showTripleDigits: PropTypes.bool,
	transparent: PropTypes.bool,
	warning: PropTypes.bool,
	white: PropTypes.bool
}

Unread.defaultProps = {
	empty: false,
	red: false,
	gray: false,
	small: false,
	showTripleDigits: false,
	transparent: false,
	warning: false,
	white: false
}

export const StyledUnread = styled.span`
	font-size: 0.7rem;
	font-weight: bold;
	text-align: right;
	margin-left: auto;

	background: ${props => props.theme.primary};
	border-radius: 11px;
	color: ${props => props.theme.white};
	height: 22px;
	min-width: 22px;

	align-items: center;
	display: flex;
	justify-content: center;

	${props => props.small && `
		border-radius: 9px;
		height: 18px;
		min-width: 18px;
	`}

	${props => props.tripleDigits && `
		padding: 0 0.35rem;
	`}

	${props => props.warning && `
		background: ${props.theme.orange};
	`}

	${props => props.red && `
		background: ${props.theme.red};
	`}

	${props => props.gray && `
		background: ${props.theme.backgroundDark};
	`}

	${props => props.transparent && `
		background: ${props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
		color: ${props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)'};
	`}

	${props => props.empty && `
		opacity: 0.5;
	`}

	${props => props.white && `
		background: ${props.theme.white};
		color: ${props.theme.text};
	`}
`

export default Unread
